import seed from 'seed-random';
import crc32 from 'crc32';

export default new (function(){
	var me = this;
	this.animationEnd = 'animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd';
	this.transitionEnd = 'transitionend webkitTransitionEnd oTransitionEnd otransitionend';
	this.transition = ['-webkit-transition', '-moz-transition', '-ms-transition', '-o-transition', 'transition'];
	this.transform = ["-webkit-transform", "-moz-transform", "-ms-transform", "-o-transform", "transform"];
	this.property = function(keys, value, obj){
		var res = obj ? obj : {};
		for(var i=0; i<keys.length; i++){
			res[keys[i]]=value;
		}
		return res;
	}
	this.getUrlParameter = function(sParam, qString=false){
		var sPageURL = qString !== false ? qString : window.location.search.substring(1);
		var sURLVariables = sPageURL.split('&');
		for (var i = 0; i < sURLVariables.length; i++) {
			var sParameterName = sURLVariables[i].split('=');
			if (sParameterName[0] == sParam) {
				return decodeURI(sParameterName[1]);
			}
		}
		return false;
	}
	var timer;
	var timerStart;
	this.time = function(label, isTotal){
		if(!timer){
			timer = Date.now();
			timerStart = timer;
			console.log('==== Timer started'+(label ? ' | '+label : ''));
		}else{
			var t = Date.now();
			console.log('==== '+(t-timer)+' ms'+(label ? ' | '+label : ''));
			timer = t;
			if(isTotal){
				console.log('==== Total: '+(t-timerStart)+' ms');
			}
		}
	}
	this.parents = function(el, selector) {
		var elements = [];
		var elem = el;
		var ishaveselector = selector !== undefined;
		while ((elem = elem.parentElement) !== null) {
			if (elem.nodeType !== Node.ELEMENT_NODE) {
				continue;
			}
	
			if (!ishaveselector || elem.matches(selector)) {
				elements.push(elem);
			}
		}
		return elements;
	};
	this.triggerEvent = function(el, evName){
		var event = document.createEvent('HTMLEvents');
		event.initEvent(evName, true, false);
		el.dispatchEvent(event);
	}
	this.triggerCustomEvent = function(el, evName, data){
		var event;
		if (window.CustomEvent) {
			event = new CustomEvent(evName, {detail: data});
		} else {
			event = document.createEvent('CustomEvent');
			event.initCustomEvent(evName, true, true, data);
		}
		el.dispatchEvent(event);
	}
	this.insertQueryParam = function(url, key, value) {
		const addQ = key + '=' + value;
		if(!url){
			return url;
		}
		const split = url.split('?');
		if(!split || split.length < 1){
			return url;
		}
		const addr = split[0];
		const q = split.length > 1 ? split[1] : '';
		if(this.getUrlParameter(key, q)){
			return url;
		}
		return addr + '?' + (q.length > 0 ? q + '&' + addQ : addQ)
	}
	
	this.isWebGLAvailable = function () {
		try {
			var canvas = document.createElement( 'canvas' );
			return !! ( window.WebGLRenderingContext && ( canvas.getContext( 'webgl' ) || canvas.getContext( 'experimental-webgl' ) ) );
		} catch ( e ) {
			return false;
		}
	}
	this.isWebGL2Available = function () {
		try {
			var canvas = document.createElement( 'canvas' );
			return !! ( window.WebGL2RenderingContext && canvas.getContext( 'webgl2' ) );
		} catch ( e ) {
			return false;
		}
	}
	this.isPhoton = function(){
		return document.documentElement.getAttribute('data-glowz-photon-mode');
	}
	this.photonUrl = function(srcUrl){
		const PARSE_BASE_HOST = '__domain__.invalid';
		const PARSE_BASE_URL = `http://${ PARSE_BASE_HOST }`;
		const PHOTON_BASE_URL = 'https://i0.wp.com';
		try{
			const parsedUrl = new URL( srcUrl, PARSE_BASE_URL );
			if ( !parsedUrl.search && !(/^i[0-2]\.wp\.com$/.test(parsedUrl.host)) ) {
				const lowPath = parsedUrl.pathname.toLowerCase();
				const ind4 = lowPath.length - 4;
				const ind5 = lowPath.length - 5;
				if(
					lowPath.indexOf('.jpg') === ind4 ||
					lowPath.indexOf('.gif') === ind4  ||
					lowPath.indexOf('.png') === ind4  ||
					lowPath.indexOf('.jpeg') === ind5 ||
					lowPath.indexOf('.webp') === ind5
				){
					const photonUrl = new URL( PHOTON_BASE_URL );
					let formattedUrl;
					if ( parsedUrl.hostname === PARSE_BASE_HOST ) {
						formattedUrl = parsedUrl.pathname;
					}else{
						formattedUrl = parsedUrl.href.replace( `${ parsedUrl.protocol }/`, '' );
					}
					const isSecure = parsedUrl.protocol === 'https:';
					photonUrl.pathname = formattedUrl;
					const hash = crc32( formattedUrl );
					const rng = seed( hash );
					const server = 'i' + Math.floor( rng() * 3 );
					photonUrl.hostname = server + '.wp.com';
					if ( isSecure ) {
						photonUrl.searchParams.set( 'ssl', 1 );
					}
					return photonUrl.href;
				}else{
					return srcUrl;
				}
			}
		}catch{
			return srcUrl;
		}
	}
	this.passiveListener = false;
	try {
		var opts = Object.defineProperty({}, 'passive', {
			get: function() {
			this.passiveListener = true;
			}
		});
		window.addEventListener("testPassive", null, opts);
		window.removeEventListener("testPassive", null, opts);
	} catch (e) {}
	
	this.debounce = (fn) => {
		let frame;
		return (...params) => {
			if (frame) {
				cancelAnimationFrame(frame);
			}
			frame = requestAnimationFrame(() => {
				fn(...params);
			});
		};
	};
	
})();
